module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2017_14.891d42a9.jpg";